import box  from "./urStepBox";
import item from "./urStepItem";
export default {
    install(Vue){
        Vue.component(box.name,  box);
        Vue.component(item.name, item);
    }
};
